// <nursery-bundle> — build-your-own bundle add-ons with real colourway swatches, single /cart/add.js call, client-side discount preview.
class NurseryBundle extends HTMLElement {
  connectedCallback() {
    this.baseVariantId = this.dataset.baseVariant;
    this.basePrice = parseFloat(this.dataset.basePrice);
    this.threshold = parseInt(this.dataset.discountThreshold, 10) || 2;
    this.discountAmount = parseFloat(this.dataset.discountAmount) || 0;
    this.selected = new Map();

    this.cards = Array.from(this.querySelectorAll('[data-addon-toggle]'));
    this.cards.forEach(function (card) {
      card.addEventListener('click', this.onToggle.bind(this));
    }.bind(this));

    this.swatches = Array.from(this.querySelectorAll('[data-addon-swatch]'));
    this.swatches.forEach(function (swatch) {
      swatch.addEventListener('click', this.onSwatch.bind(this));
    }.bind(this));

    var addBtn = this.querySelector('[data-bundle-add]');
    if (addBtn) addBtn.addEventListener('click', this.onAdd.bind(this));

    this.render();
  }

  onToggle(e) {
    var card = e.currentTarget;
    var variantId = card.dataset.variantId;
    var wrapper = card.closest('[data-addon-wrapper]');
    if (this.selected.has(variantId)) {
      this.selected.delete(variantId);
      wrapper.classList.remove('selected');
    } else {
      this.selected.set(variantId, parseFloat(card.dataset.price));
      wrapper.classList.add('selected');
    }
    this.render();
  }

  onSwatch(e) {
    var swatch = e.currentTarget;
    var wrapper = swatch.closest('[data-addon-wrapper]');
    var toggle = wrapper.querySelector('[data-addon-toggle]');
    var oldVariantId = toggle.dataset.variantId;
    var wasSelected = this.selected.has(oldVariantId);

    var newVariantId = swatch.dataset.variantId;
    var newPrice = parseFloat(swatch.dataset.price);

    toggle.dataset.variantId = newVariantId;
    toggle.dataset.price = newPrice;
    toggle.querySelector('[data-addon-image]').src = swatch.dataset.image;
    toggle.querySelector('[data-addon-price]').textContent = swatch.dataset.priceDisplay;

    var colourEl = wrapper.querySelector('[data-addon-colour]');
    if (colourEl) colourEl.textContent = 'Colour: ' + swatch.dataset.colourName;

    var infoEl = wrapper.querySelector('[data-addon-info]');
    if (infoEl && swatch.dataset.url) infoEl.setAttribute('href', swatch.dataset.url);

    wrapper.querySelectorAll('[data-addon-swatch]').forEach(function (s) { s.classList.remove('active'); });
    swatch.classList.add('active');

    if (wasSelected) {
      this.selected.delete(oldVariantId);
      this.selected.set(newVariantId, newPrice);
    }
    this.render();
  }

  formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  render() {
    var subtotal = this.basePrice;
    this.selected.forEach(function (price) { subtotal += price; });

    var pieceCount = 1 + this.selected.size;
    var discountApplies = pieceCount >= this.threshold && this.discountAmount > 0;
    var discountAmount = discountApplies ? this.discountAmount : 0;
    var total = subtotal - discountAmount;

    var subtotalEl = this.querySelector('[data-summary-subtotal]');
    var discountRow = this.querySelector('[data-summary-discount-row]');
    var discountLabel = this.querySelector('[data-summary-discount-label]');
    var discountAmountEl = this.querySelector('[data-summary-discount-amount]');
    var totalEl = this.querySelector('[data-summary-total]');

    if (subtotalEl) subtotalEl.textContent = this.formatMoney(subtotal);
    if (discountRow) discountRow.hidden = !discountApplies;
    if (discountApplies) {
      if (discountLabel) discountLabel.textContent = 'Bundle discount';
      if (discountAmountEl) discountAmountEl.textContent = '−' + this.formatMoney(discountAmount);
    }
    if (totalEl) totalEl.textContent = this.formatMoney(total);
  }

  onAdd(e) {
    var btn = e.currentTarget;
    var items = [{ id: this.baseVariantId, quantity: 1 }];
    this.selected.forEach(function (price, variantId) {
      items.push({ id: variantId, quantity: 1 });
    });

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: items }),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        btn.textContent = 'Added to cart';
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800);
      })
      .catch(function (err) {
        console.error('Bundle add to cart failed', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }
}
customElements.define('nursery-bundle', NurseryBundle);
